import React from "react";
import PropTypes from "prop-types";
import { translate } from "application/functions";
import mobileError from "assets/img/error/mobile.jpg";
import webError from "assets/img/error/web.jpg";
import withSizeWindow from "application/hoc/with-size-window";

const ErrorPage = (props) => {
  const { size } = props;

  const getImage = () => {
    if (size === "xs_vertical" || size === "") {
      return mobileError;
    }
    return webError;
  };

  const getVeil = () => {
    if (size === "ultrawide") {
      return "linear-gradient(0deg, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), ";
    }
    return "";
  };

  return (
    <div className="error-page__container" style={{ backgroundImage: `${getVeil()}url(${getImage()}` }}>
      <div className="error-page__message">
        <div className="error-page__title">{translate(`error.title.generic`)}</div>
        <div className="error-page__text">{translate(`error.text`)}</div>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  size: PropTypes.string,
};

export default withSizeWindow(ErrorPage);
